export const getService = () => {
  const token = localStorage.getItem("token");
  const reqestURL = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_V}/services`;
  const reqestHeader = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  return fetch(reqestURL, {
    method: "GET",
    headers: reqestHeader,
  })
    .then((response) => response.json())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const addService = () => {
  const token = localStorage.getItem("token");
  const reqestURL = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_V}/services`;
  const reqestHeader = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  const input = {
    name: "อุปกรณ์ประกอบสายไฟฟ้าสาธารณะ",
    category: "data",
    type: "electric",
    endpoint: "ls-inline-equipments",
    charging_condition_id: "5f0ac12874161fa7215ea26b",
    vallaris_dataset_id: "5eafff11db447a9e67f518d9",
    ignore_items: [],
    user_roles: ["root", "admin", "officer"],
    user_specials: [],
    custom: false,
    enabled: true,
  };

  return fetch(reqestURL, {
    method: "POST",
    headers: reqestHeader,
    body: JSON.stringify(input),
  })
    .then((response) => response.json())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getServiceUser = (uid) => {
  const token = localStorage.getItem("token");
  const reqestURL = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_V}/services?user_id=${uid}`;
  const reqestHeader = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  return fetch(reqestURL, {
    method: "GET",
    headers: reqestHeader,
  })
    .then((response) => response.json())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const editServiceMore = (sid, input) => {
  const token = localStorage.getItem("token");
  const reqestURL = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_V}/services/${sid}`;
  const reqestHeader = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  return fetch(reqestURL, {
    method: "PUT",
    headers: reqestHeader,
    body: JSON.stringify(input),
  })
    .then((response) => response.json())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
